import React from 'react';
const BeautySpa = () => <div className="service-page"><h1>Beauty Spa</h1><p>Relax and rejuvenate at the best beauty spas in your city.</p></div>;
export default BeautySpa;
